import React from 'react'

import * as Yup from 'yup'
import { Form, Select, Switch } from 'formik-antd'
import InputColor from 'react-input-color'

import { BasicForm } from '../../../../core/components/form'
import { usePostForm, useFetch } from '../../../../hooks/admin/theme'
import { useHistory } from 'react-router-dom'
import Loader from '../../../../components/loader'
import { isNotValid, translateSymfonyErrorToFormik } from '../../../../core/utils/form'
import { FONTS, defaultTheme } from '../../../../config/theme'
import { testTheme, getTheme } from '../../../../hooks/useTheme'

const ValidationSchema = Yup.object().shape({
  primaryColor: Yup.string().required('Cannot be blank.'),
  errorColor: Yup.string().required('Cannot be blank.'),
  successColor: Yup.string().required('Cannot be blank.'),
  warningColor: Yup.string().required('Cannot be blank.'),
  infoColor: Yup.string().required('Cannot be blank.')
})

const Formulario = () => {
  const { data, isLoading, isError } = useFetch()
  const { data: currentTheme, isLoading: isLoadedCurrentTheme } = getTheme()
  const update = usePostForm()
  const history = useHistory()

  function handleSubmit (values, bag) {
    //const form = { ...values }

    const form = new FormData()
    form.append('primaryColor', values.primaryColor)
    form.append('successColor', values.successColor)
    form.append('errorColor', values.errorColor)
    form.append('warningColor', values.warningColor)
    form.append('infoColor', values.infoColor)
    form.append('lightColor', values.lightColor)
    form.append('darkColor', values.darkColor)
    form.append('darkHeader', values.darkHeader)
    form.append('darkMenu', values.darkMenu)
    form.append('fontFamily', values.fontFamily)

    update.mutate(form, {
      onSuccess: (data) => {
        bag.setSubmitting(false)
        onPressBack()
      },
      onError: (error, variables, context) => {
        bag.setSubmitting(false)
        if (error.response.status === 400) {
          const data = error.response?.data
          if (isNotValid(data)) {
            bag.setErrors(translateSymfonyErrorToFormik(data?.errors?.children))
          }
        }
      }
    })
  }

  const previewTheme = (values) => testTheme(currentTheme, values)

  const onColorChange = (setField, field, value, values) => {
    setField(field, value.hex)
  }

  const onPressBack = () => history.goBack()

  if (isLoading || isLoadedCurrentTheme) {
    return (<Loader loading={isLoading} />)
  }

  if (isError) {
    return (<>Error</>)
  }

  const initialValues =
    data
      ? {
          primaryColor: data?.primaryColor,
          errorColor: data?.errorColor,
          successColor: data?.successColor,
          warningColor: data?.warningColor,
          infoColor: data?.infoColor,
          lightColor: data.lightColor,
          darkColor: data?.darkColor,
          fontFamily: data?.fontFamily,
          darkHeader: data?.darkHeader === 'true',
          darkMenu: data?.darkMenu === 'true'
        }
      : defaultTheme

  return (
    <BasicForm
      onPressBack={onPressBack}
      titulo='THEME'
      initialValues={initialValues}
      validationSchema={ValidationSchema}
      onSubmit={handleSubmit}
      onSecondaryButton={previewTheme}
      secondaryButtonLabel='Preview'
      render={({ values, setFieldValue }) => (
        <>
          <Form.Item label='Dark header' name='darkHeader' hasFeedback>
            <Switch name='darkHeader' />
          </Form.Item>

          <Form.Item label='Dark menu' name='darkMenu' hasFeedback>
            <Switch name='darkMenu' />
          </Form.Item>

          <Form.Item
            label='Font Family'
            name='fontFamily'
            showValidateSuccess
            hasFeedback
            required
          >
            <Select name='fontFamily' style={{ width: '100%' }} placeholder='Font Family' options={FONTS} />
          </Form.Item>

          {/*
          <Form.Item name='lightColor' label='Light Color' required>
            <InputColor
              name='lightColor'
              initialValue={values.lightColor}
              onChange={(value) => onColorChange(setFieldValue, 'lightColor', value, values)}
              style={{ width: '100%', height: 48 }}
            />
          </Form.Item>
          */}

          <Form.Item name='darkColor' label='Dark Color' required>
            <InputColor
              name='darkColor'
              initialValue={values.darkColor}
              onChange={(value) => onColorChange(setFieldValue, 'darkColor', value, values)}
              style={{ width: '100%', height: 48 }}
            />
          </Form.Item>

          <Form.Item name='primaryColor' label='Primary Color' required>
            <InputColor
              name='primaryColor'
              initialValue={values.primaryColor}
              onChange={(value) => onColorChange(setFieldValue, 'primaryColor', value, values)}
              style={{ width: '100%', height: 48 }}
            />
          </Form.Item>
          <Form.Item name='errorColor' label='Error Color' required>
            <InputColor
              name='errorColor'
              initialValue={values.errorColor}
              onChange={(value) => onColorChange(setFieldValue, 'errorColor', value, values)}
              style={{ width: '100%', height: 48 }}
            />
          </Form.Item>
          <Form.Item name='successColor' label='Success Color' required>
            <InputColor
              name='successColor'
              initialValue={values.successColor}
              onChange={(value) => onColorChange(setFieldValue, 'successColor', value, values)}
              style={{ width: '100%', height: 48 }}
            />
          </Form.Item>
          <Form.Item name='warningColor' label='Warning Color' required>
            <InputColor
              name='warningColor'
              initialValue={values.warningColor}
              onChange={(value) => onColorChange(setFieldValue, 'warningColor', value, values)}
              style={{ width: '100%', height: 48 }}
            />
          </Form.Item>
          <Form.Item name='infoColor' label='Info Color' required>
            <InputColor
              name='infoColor'
              initialValue={values.infoColor}
              onChange={(value) => onColorChange(setFieldValue, 'infoColor', value, values)}
              style={{ width: '100%', height: 48 }}
            />
          </Form.Item>
        </>
      )}
    />
  )
}

export default Formulario
